// extracted by mini-css-extract-plugin
export default {"filters-group":"FiltersGroup_filters-group__-kC6Z"};